export const conversationsObjectsNewUI = (locationId: string) => {
  const enableNew = localStorage?.getItem('enableNew')
  if (enableNew === 'levelup-new-ui') {
    return true
  }
  const prodLocations = ['HybYcmw5Nrspu9bv3hP9', 'zTWfcNDEa8aXdijpY9Vp', '2vaibezO8VX2AYJqu5OJ', 'VsCb4ghBsfQSahsP0ofT']
  const nonProdLocations = ['HChooFuiyPpVYzeJ4HMe', 'IvBwSU2axCqEYAWU8JQL', 'UpB0FBEJTbBe5py6gAl2']
  const allowAnyway =
    ((process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'beta') && prodLocations.includes(locationId)) ||
    nonProdLocations.includes(locationId)
  return allowAnyway
}
